export enum DTCFlowTypes {
  PER_SHIPMENT = 'per_shipment',
  ANNUAL_POLICY = 'annual_policy',
  TRADE_CREDIT_INSURANCE = 'trade_credit_insurance',
}

export const TERMS_OF_USE_URL = 'https://www.breezeai.com/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://www.breezeai.com/privacy-policy';
